import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import BannerScreen from "./BannerScreen.vue";
import CoreFunctions from "./CoreFunctions.vue";
import VideoMore from "./VideoMore.vue";
import Partner from "./Partner.vue";
import MobileTabs from "./MobileTabs.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const router = useRouter();
const store = useStore();
const isMobile = computed(() => store.state.isMobile);
onMounted(() => {
  const isLoginActive = router.currentRoute.value.query.islogin;
  if (isLoginActive) {
    store.commit("showLogin");
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BannerScreen),
    (!_unref(isMobile))
      ? (_openBlock(), _createBlock(CoreFunctions, { key: 0 }))
      : (_openBlock(), _createBlock(MobileTabs, { key: 1 })),
    _createVNode(VideoMore),
    _createVNode(Partner)
  ], 64))
}
}

})